import { FC, memo, useMemo } from 'react';
import cx from 'clsx';
import { useDataContext } from 'src/contexts';

import { MediaGridItem } from './MediaGridItem';

import styles from './styles.module.css';

export const MediaGrid: FC = memo(() => {
  const pvoData = useDataContext((ctx) => ctx.pvoData);

  const data = pvoData.files;
  const itemCount = data.length;

  const mediaItems = useMemo(
    () => data.map((asset) => <MediaGridItem key={asset.id} data={asset} />),
    [data]
  );

  if (!itemCount) return;

  return (
    <div
      className={cx({
        [styles.container]: true,
        [styles.containerOverflow]: data.length > 2,
      })}
    >
      <div
        className={cx({
          [styles.gridSingle]: itemCount === 1,
          [styles.gridMultiple]: itemCount >= 5,
        })}
      >
        {mediaItems}
      </div>
    </div>
  );
});
